import React from "react";
import PriceFreezeIcon from "../../assets/icons/amenities/pricefreeze.svg?react";
import EarlyCheckInCalendarIcon from "../../assets/icons/cap1/calendar-icon.svg?react";
import PriceDropProtectionShield from "../../assets/icons/cap1/price-drop-protection-shield.svg?react";
import PriceDropProtectionIcon from "../../assets/icons/cap1/price-drop-protection.svg?react";
import PriceFreezeArrow from "../../assets/icons/cap1/price-freeze-arrow.svg?react";
import B2bPriceFreezeNoCircle from "../../assets/icons/cap1/price-freeze-no-circle.svg?react";
import B2bPriceFreeze from "../../assets/icons/cap1/price-freeze.svg?react";
import PriceMatchGuaranteeIcon from "../../assets/icons/cap1/price-match-icon.svg?react";
import PricePredictionIcon from "../../assets/icons/cap1/price-prediction.svg?react";
import UnableToProcess from "../../assets/icons/cap1/unable-to-process.svg?react";
import UpgradeIcon from "../../assets/icons/cap1/upgrade-icon.svg?react";
import AirConditioningIcon from "../../assets/icons/car/amenities/air-conditioning-icon.svg?react";
import CarIcon from "../../assets/icons/car/car-icon.svg?react";
import TransmissionIcon from "../../assets/icons/car/transmission-icon.svg?react";
import ErrorAlertIcon from "../../assets/icons/common/alert-error.svg?react";
import WarningAlertOutlineThinIcon from "../../assets/icons/common/alert-warning-outline-thin.svg?react";
import WarningAlertOutlineIcon from "../../assets/icons/common/alert-warning-outline.svg?react";
import WarningAlertIcon from "../../assets/icons/common/alert-warning.svg?react";
import ArrowDiverge from "../../assets/icons/common/arrow-diverge.svg?react";
import ArrowRight from "../../assets/icons/common/arrow-right.svg?react";
import Arrows from "../../assets/icons/common/arrows.svg?react";
import B2BAirplaneIcon from "../../assets/icons/common/b2b-airplane-icon.svg?react";
import B2BEditPencilIcon from "../../assets/icons/common/b2b-edit-pencil.svg?react";
import B2BMapPin from "../../assets/icons/common/b2b-map-pin.svg?react";
import B2BOriginIcon from "../../assets/icons/common/b2b-origin-icon.svg?react";
import B2BPriceWatch from "../../assets/icons/common/b2b-price-watch.svg?react";
import B2BUser from "../../assets/icons/common/b2b-user.svg?react";
import BellWarningIcon from "../../assets/icons/common/bell-warning-icon.svg?react";
import CalendarIcon from "../../assets/icons/common/calendar.svg?react";
import CarryOnBaggage from "../../assets/icons/common/carry-on-baggage.svg?react";
import CheckCircleFilledBlueIcon from "../../assets/icons/common/check-circle-filled-blue.svg?react";
import CheckCircleOutlineIcon from "../../assets/icons/common/check-circle-outline.svg?react";
import CheckCircleIcon from "../../assets/icons/common/check-circle.svg?react";
import CheckCircleFilledIcon from "../../assets/icons/common/check-filled.svg?react";
import CheckInCalendar from "../../assets/icons/common/check-in-calendar.svg?react";
import CheckCircleTransparentIcon from "../../assets/icons/common/check-mark-transparent.svg?react";
import CheckOutCalendar from "../../assets/icons/common/check-out-calendar.svg?react";
import CheckShieldBlueIcon from "../../assets/icons/common/check-shield-blue.svg?react";
import CheckShieldIcon from "../../assets/icons/common/check-shield.svg?react";
import ChevronDown from "../../assets/icons/common/chevron-down.svg?react";
import CircleAirplane from "../../assets/icons/common/circle-airplane.svg?react";
import CircleAlert from "../../assets/icons/common/circle-alert.svg?react";
import ClockIcon from "../../assets/icons/common/clock.svg?react";
import CloseBlack from "../../assets/icons/common/close-black.svg?react";
import Close from "../../assets/icons/common/close-button.svg?react";
import ComboFlight from "../../assets/icons/common/combo-flight.svg?react";
import Checkmark from "../../assets/icons/common/confirmation-check-mark.svg?react";
import DecreaseIcon from "../../assets/icons/common/decrease-arrow.svg?react";
import Dropdown from "../../assets/icons/common/dropdown.svg?react";
import ExternalLinkIcon from "../../assets/icons/common/external-link-icon.svg?react";
import FilledClock from "../../assets/icons/common/filled-clock.svg?react";
import FilterMenuThick from "../../assets/icons/common/filter-menu-thick.svg?react";
import FilterMenu from "../../assets/icons/common/filter-menu.svg?react";
import PoundCurrencySymbol from "../../assets/icons/common/gbp.svg?react";
import Gear from "../../assets/icons/common/gear.svg?react";
import GenericIcon from "../../assets/icons/common/generic.svg?react";
import BellAlertIcon from "../../assets/icons/common/grey-bell-alert-icon.svg?react";
import CheckedIcon from "../../assets/icons/common/grey-checked-icon.svg?react";
import DottedLineIcon from "../../assets/icons/common/grey-dotted-line.svg?react";
import GuaranteeIcon from "../../assets/icons/common/grey-guarantee-icon.svg?react";
import PriceDropIcon from "../../assets/icons/common/grey-price-drop-icon.svg?react";
import Hourglass from "../../assets/icons/common/hourglass.svg?react";
import IncreaseIcon from "../../assets/icons/common/increase-arrow.svg?react";
import InfoCircleFillIcon from "../../assets/icons/common/info-circle-fill.svg?react";
import InfoCircleIcon from "../../assets/icons/common/info-icon.svg?react";
import InfoCircleWhiteIcon from "../../assets/icons/common/info-white-icon.svg?react";
import LeftArrowCircle from "../../assets/icons/common/left-arrow-circle.svg?react";
import LinkArrow from "../../assets/icons/common/link-arrow.svg?react";
import MagnifyingGlassIcon from "../../assets/icons/common/magnifying-glass-icon.svg?react";
import MoneyFill from "../../assets/icons/common/money-fill.svg?react";
import MoneyOutlineGBPIcon from "../../assets/icons/common/money-outline-gbp.svg?react";
import MoneyOutlineTransparentIcon from "../../assets/icons/common/money-outline-transparent.svg?react";
import MoneyOutlineIcon from "../../assets/icons/common/money-outline.svg?react";
import NotAllowedSignIcon from "../../assets/icons/common/not-allowed-sign.svg?react";
import PaymentIcon from "../../assets/icons/common/payment.svg?react";
import PencilEditIcon from "../../assets/icons/common/pencil-edit-icon.svg?react";
import PlusOutline from "../../assets/icons/common/plus-outline.svg?react";
import Refresh from "../../assets/icons/common/refresh.svg?react";
import Reload from "../../assets/icons/common/reload.svg?react";
import Repayments from "../../assets/icons/common/repayments.svg?react";
import RewindIcon from "../../assets/icons/common/rewind-time.svg?react";
import RightArrowCircle from "../../assets/icons/common/right-arrow-circle.svg?react";
import ShieldPayment from "../../assets/icons/common/shield-payment.svg?react";
import ShowAllImagesIcon from "../../assets/icons/common/show-all-images.svg?react";
import StarEmpty from "../../assets/icons/common/star-empty.svg?react";
import StarFilled from "../../assets/icons/common/star-filled.svg?react";
import SubtractIcon from "../../assets/icons/common/subtract.svg?react";
import SuiteCaseIcon from "../../assets/icons/common/suitecase-icon.svg?react";
import Delete from "../../assets/icons/common/trash-bin-icon.svg?react";
import TripProtectionCrossSolid from "../../assets/icons/common/trip-protection-cross-solid.svg?react";
import TripProtection from "../../assets/icons/common/trip-protection.svg?react";
import UserIcon from "../../assets/icons/common/user.svg?react";
import ErrorState from "../../assets/icons/common/warning-icon-orange.svg?react";
import B2BWatchCheckedIcon from "../../assets/icons/common/watch-b2b-checked.svg?react";
import B2BWatchIcon from "../../assets/icons/common/watch-b2b.svg?react";
import WatchIcon from "../../assets/icons/common/watch.svg?react";
import WorldMap from "../../assets/icons/common/world-map.svg?react";
import XCircleFilled from "../../assets/icons/common/x-circle-filled.svg?react";
import AirplaneGrey from "../../assets/icons/flight/airplane_grey.svg?react";
import BookTravel from "../../assets/icons/flight/book-travel.svg?react";
import FrozenPriceIcon from "../../assets/icons/flight/frozen-price.svg?react";
import SeatSelectionIcon from "../../assets/icons/flight/seat-selection.svg?react";
import HopperLogo from "../../assets/icons/hopper/hopper-logo.svg?react";
import Bed from "../../assets/icons/hotel/bed.svg?react";
import Hotel from "../../assets/icons/hotel/hotels-icon.svg?react";
import MapPinRound from "../../assets/icons/hotel/map-pin-round.svg?react";
import MapPin from "../../assets/icons/hotel/map-pin.svg?react";
import CardIcon from "../../assets/icons/payments/card_generic.svg?react";
import SendMessage from "../../assets/icons/support/send-message.svg?react";
import StarRoundedEmpty from "../../assets/icons/support/star-rounded-empty.svg?react";
import StarRoundedFilled from "../../assets/icons/support/star-rounded-filled.svg?react";
import SupportChat from "../../assets/icons/support/support-chat.svg?react";
import SupportChevronRight from "../../assets/icons/support/support-chevron-right.svg?react";
import SupportPhoneIntl from "../../assets/icons/support/support-phone-intl.svg?react";
import SupportPhone from "../../assets/icons/support/support-phone.svg?react";
import CheckSolid from "../../assets/icons/system/check-solid.svg?react";
import DecreaseReviewed from "../../assets/icons/system/DecreaseReviewed.svg?react";
import DismissOutline from "../../assets/icons/system/dismiss-outline.svg?react";
import IncreaseReviewed from "../../assets/icons/system/IncreaseReviewed.svg?react";
import LockIcon from "../../assets/icons/system/lock.svg?react";
import NavigationForwardIcon from "../../assets/icons/system/navigation-forward.svg?react";
import RoundArrowDown from "../../assets/icons/system/round-arrow-down.svg?react";
import CabinLuggage from "../../assets/icons/uber/cabin.svg?react";
import CheckedLuggage from "../../assets/icons/uber/checked-luggage.svg?react";
import Chevron from "../../assets/icons/uber/chevron.svg?react";
import Forbidden from "../../assets/icons/uber/forbidden.svg?react";
import MoneyGBP from "../../assets/icons/uber/gbp.svg?react";
import PersonalItemLuggage from "../../assets/icons/uber/personal-item.svg?react";

import { IconName } from "../Icon/component";
import type { SvgrComponent } from "../typings";
import "./styles.scss";

type IconComponentMap = {
  [name in IconName]: SvgrComponent;
};

export const iconComponentMap: IconComponentMap = {
  [IconName.MoneyOutline]: MoneyOutlineIcon,
  [IconName.MoneyOutlineGBP]: MoneyOutlineGBPIcon,
  [IconName.MoneyOutlineTransparentIcon]: MoneyOutlineTransparentIcon,
  [IconName.MoneyFill]: MoneyFill,
  [IconName.MoneyGBP]: MoneyGBP,
  [IconName.CheckCircle]: CheckCircleIcon,
  [IconName.Payment]: PaymentIcon,
  [IconName.CheckCircleTransparent]: CheckCircleTransparentIcon,
  [IconName.CheckCircleOutline]: CheckCircleOutlineIcon,
  [IconName.CheckShield]: CheckShieldIcon,
  [IconName.CheckShieldBlue]: CheckShieldBlueIcon,
  [IconName.NotAllowedSign]: NotAllowedSignIcon,
  [IconName.PriceFreeze]: PriceFreezeIcon,
  [IconName.NavigationForward]: NavigationForwardIcon,
  [IconName.Lock]: LockIcon,
  [IconName.Person]: UserIcon,
  [IconName.User]: UserIcon,
  [IconName.Rewind]: RewindIcon,
  [IconName.Card]: CardIcon,
  [IconName.Watch]: WatchIcon,
  [IconName.Increase]: IncreaseIcon,
  [IconName.Decrease]: DecreaseIcon,
  [IconName.MapPin]: MapPin,
  [IconName.MapPinRound]: MapPinRound,
  [IconName.B2BWatch]: B2BWatchIcon,
  [IconName.B2BWatchChecked]: B2BWatchCheckedIcon,
  [IconName.IncreasedReviewed]: IncreaseReviewed,
  [IconName.DecreaseReviewed]: DecreaseReviewed,
  [IconName.PlusOutline]: PlusOutline,
  [IconName.PencilEdit]: PencilEditIcon,
  [IconName.ErrorAlert]: ErrorAlertIcon,
  [IconName.WarningAlert]: WarningAlertIcon,
  [IconName.WarningAlertOutline]: WarningAlertOutlineIcon,
  [IconName.WarningAlertOutlineThin]: WarningAlertOutlineThinIcon,
  [IconName.InfoCircle]: InfoCircleIcon,
  [IconName.InfoCircleFill]: InfoCircleFillIcon,
  [IconName.InfoWhiteCircle]: InfoCircleWhiteIcon,
  [IconName.Calendar]: CalendarIcon,
  [IconName.CheckInCalendar]: CheckInCalendar,
  [IconName.CheckOutCalendar]: CheckOutCalendar,
  [IconName.B2BEditPencil]: B2BEditPencilIcon,
  [IconName.Dropdown]: Dropdown,
  [IconName.B2BUser]: B2BUser,
  [IconName.B2BMapPin]: B2BMapPin,
  [IconName.SuiteCase]: SuiteCaseIcon,
  [IconName.Transmission]: TransmissionIcon,
  [IconName.AirConditioning]: AirConditioningIcon,
  [IconName.ClockIcon]: ClockIcon,
  [IconName.Car]: CarIcon,
  [IconName.BookTravel]: BookTravel,
  [IconName.WorldMap]: WorldMap,
  [IconName.CircleAirplane]: CircleAirplane,
  [IconName.CheckCircleFilled]: CheckCircleFilledIcon,
  [IconName.Generic]: GenericIcon,
  [IconName.MagnifyingGlass]: MagnifyingGlassIcon,
  [IconName.B2BAirplaneIcon]: B2BAirplaneIcon,
  [IconName.B2BOriginIcon]: B2BOriginIcon,
  [IconName.ShowAllImagesIcon]: ShowAllImagesIcon,
  [IconName.StarFilled]: StarFilled,
  [IconName.StarEmpty]: StarEmpty,
  [IconName.StarRoundedFilled]: StarRoundedFilled,
  [IconName.StarRoundedEmpty]: StarRoundedEmpty,
  [IconName.B2BPriceWatch]: B2BPriceWatch,
  [IconName.ExternalLinkIcon]: ExternalLinkIcon,
  [IconName.ErrorState]: ErrorState,
  [IconName.UnableToProcess]: UnableToProcess,
  [IconName.B2bPriceFreeze]: B2bPriceFreeze,
  [IconName.B2bPriceFreezeNoCircle]: B2bPriceFreezeNoCircle,
  [IconName.PriceDropProtectionIcon]: PriceDropProtectionIcon,
  [IconName.PriceDropProtectionShield]: PriceDropProtectionShield,
  [IconName.Guarantee]: GuaranteeIcon,
  [IconName.BellAlert]: BellAlertIcon,
  [IconName.PriceDrop]: PriceDropIcon,
  [IconName.Checked]: CheckedIcon,
  [IconName.PricePredictionIcon]: PricePredictionIcon,
  [IconName.PriceMatchGuaranteeIcon]: PriceMatchGuaranteeIcon,
  [IconName.DottedLine]: DottedLineIcon,
  [IconName.PriceFreezeArrow]: PriceFreezeArrow,
  [IconName.SeatSelectionIcon]: SeatSelectionIcon,
  [IconName.FrozenPrice]: FrozenPriceIcon,
  [IconName.BellWarning]: BellWarningIcon,
  [IconName.EarlyCheckInCalendarIcon]: EarlyCheckInCalendarIcon,
  [IconName.UpgradeIcon]: UpgradeIcon,
  [IconName.CheckCircleFilledBlue]: CheckCircleFilledBlueIcon,
  [IconName.HopperLogo]: HopperLogo,
  [IconName.FilterMenu]: FilterMenu,
  [IconName.FilterMenuThick]: FilterMenuThick,
  [IconName.Checkmark]: Checkmark,
  [IconName.Delete]: Delete,
  [IconName.Close]: Close,
  [IconName.XCircleFilled]: XCircleFilled,
  [IconName.PoundCurrencySymbol]: PoundCurrencySymbol,
  [IconName.Subtract]: SubtractIcon,
  [IconName.ArrowDiverge]: ArrowDiverge,
  [IconName.Arrows]: Arrows,
  [IconName.FilledClock]: FilledClock,
  [IconName.CircleAlert]: CircleAlert,
  [IconName.Chevron]: Chevron,
  [IconName.Refresh]: Refresh,
  [IconName.Reload]: Reload,
  [IconName.ArrowRight]: ArrowRight,
  [IconName.Bed]: Bed,
  [IconName.ChevronDown]: ChevronDown,
  [IconName.ComboFlight]: ComboFlight,
  [IconName.CarryOnBaggage]: CarryOnBaggage,
  [IconName.TripProtection]: TripProtection,
  [IconName.TripProtectionCrossSolid]: TripProtectionCrossSolid,
  [IconName.ShieldPayment]: ShieldPayment,
  [IconName.CheckSolid]: CheckSolid,
  [IconName.SendMessage]: SendMessage,
  [IconName.SupportChat]: SupportChat,
  [IconName.SupportChevronRight]: SupportChevronRight,
  [IconName.SupportPhone]: SupportPhone,
  [IconName.SupportPhoneIntl]: SupportPhoneIntl,
  [IconName.RoundArrowDown]: RoundArrowDown,
  [IconName.DismissOutline]: DismissOutline,
  [IconName.Hotel]: Hotel,
  [IconName.CloseBlack]: CloseBlack,
  [IconName.LinkArrow]: LinkArrow,
  [IconName.Repayments]: Repayments,
  [IconName.AirplaneGrey]: AirplaneGrey,
  [IconName.Gear]: Gear,
  [IconName.Hourglass]: Hourglass,
  [IconName.LeftArrowCircle]: LeftArrowCircle,
  [IconName.RightArrowCircle]: RightArrowCircle,
  [IconName.Forbidden]: Forbidden,
  [IconName.PersonalItemLuggage]: PersonalItemLuggage,
  [IconName.CabinLuggage]: CabinLuggage,
  [IconName.CheckedLuggage]: CheckedLuggage,
};

export interface IconComponentProps {
  name: IconName;
  className?: string;
  ariaLabel?: string | null;
}

export const IconComponent = ({
  name,
  ariaLabel,
  className = "",
  ...props
}: IconComponentProps): React.ReactElement => {
  const IconComponent = iconComponentMap[name] as SvgrComponent;
  return (
    <IconComponent
      {...props}
      className={`${className} icon-component`}
      aria-label={ariaLabel ?? name}
    />
  );
};
